import { Injectable } from '@angular/core';
import { APIService } from './api.service';


@Injectable({
    providedIn: 'root',
})

export class CommonService {
    constructor(private readonly apiService: APIService) { }

    generateTruxLink(req) {
        return this.apiService.postWithAllResponse('BookingSlot/GenerateTruxLink', req);
    }

    checkOpenGateStatus(bookingId) {
        return this.apiService.getWithAllResponse(`TruxGateLink/CheckOpenGateStatus?bookingId=${bookingId}`)
    }

    openGate(bookingId) {
        return this.apiService.get(`TruxGateLink/OpenGate?bookingId=${bookingId}`)
    }

    getPageLogs(request) {
        return this.apiService.postWithAllResponse('Reports/PageLogs',request)
    }

    getBookingPaymentStatus(id, roleEnum ) {
        return this.apiService.getWithAllResponse(`Stripe/GetCheckOutPaymentUrlByBookingIdOrInvoiceId?id=${id}&roleEnum=${roleEnum}`);
    }
}